export const useEditorPreferencesStore = defineStore("editorPreferences", () => {
    const showSections = ref(false)

    function setShowSections(value: boolean) {
        showSections.value = value
    }

    function toggleShowSections() {
        showSections.value = !showSections.value
    }

    return {
        showSections,
        setShowSections,
        toggleShowSections
    }
}, {
    persist: {
        storage: localStorage,
        paths: ["showSections"]
    }
})
